module.exports = __webpack_public_path__ + "4b1895948e651213c1228bcd94ea13c3.mp4";